import { render, staticRenderFns } from "./InvoiceOccassion.vue?vue&type=template&id=46cecf58&scoped=true"
import script from "./InvoiceOccassion.vue?vue&type=script&lang=js"
export * from "./InvoiceOccassion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cecf58",
  null
  
)

export default component.exports